import { MessageCircle } from "lucide-react";
import { useLocation } from "react-router-dom";

const FloatingChatButton = () => {
  const location = useLocation();

  // 하단 GNB가 표시되는 페이지에서는 모바일에서 숨김
  const bottomNavPages = ['/', '/courses', '/my'];
  const hideOnMobile =
    bottomNavPages.includes(location.pathname) ||
    location.pathname.startsWith('/stay');

  return (
    <div className={`fixed bottom-6 right-6 z-50 ${hideOnMobile ? 'hidden md:block' : ''}`}>
      <button className="bg-[#FFEB3B] hover:bg-[#FDD835] text-black p-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-110 group">
        <div className="flex items-center space-x-2">
          <MessageCircle className="w-6 h-6" />
          <span className="hidden group-hover:inline-block text-sm font-semibold whitespace-nowrap">
            카카오톡 상담
          </span>
        </div>
        
        {/* Notification badge */}
        <div className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
          1
        </div>
      </button>
    </div>
  );
};

export default FloatingChatButton;
